import graphql__c67d193e921852282ba0 from "./__generated__/SubscribeMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__c67d193e921852282ba0;

function subscribe(email, id, onCompleted) {
  const variables = {
    subscribableId: id,
    email: email
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { subscribe };
